import { generatePath, useNavigate } from "react-router-dom";
import { Resource, getResourcePath } from "routers/constant";
import { useCurrentResource } from "./useCurrentResource";

export const useResourceNavigate = (resourceFromProps?: Resource) => {
  const currentResource = useCurrentResource();
  const navigate = useNavigate();

  const resource = resourceFromProps || currentResource;

  const toDetail = (id: string, params?: any) => {
    const detailPath = getResourcePath(resource, "detail");
    // First generate the base path with the ID parameter
    const basePath = generatePath(detailPath, { id });

    // Then create the query string from the remaining params
    const queryParams = new URLSearchParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          queryParams.append(key, String(value));
        }
      });
    }

    // Combine the base path with the query string
    const queryString = queryParams.toString();
    const path = queryString ? `${basePath}?${queryString}` : basePath;

    navigate(path);
  };

  const toEdit = (id: string) => {
    const detailPath = getResourcePath(resource, "edit");
    const path = generatePath(detailPath, { id });
    navigate(path);
  };

  const toList = () => {
    const listPath = getResourcePath(resource, "list");
    const path = generatePath(listPath);
    navigate(path);
  };

  const toCreate = () => {
    const createPath = getResourcePath(resource, "create");
    const path = generatePath(createPath);
    navigate(path);
  };

  return {
    toCreate,
    toList,
    toDetail,
    toEdit,
  };
};
